import { render, staticRenderFns } from "./PreviewSectionTitle.vue?vue&type=template&id=27ebedc1&functional=true"
var script = {}
import style0 from "./PreviewSectionTitle.vue?vue&type=style&index=0&id=27ebedc1&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports